import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CourseManagerService } from '../../networking/services/course-manager.service';
import { SharedDataService } from '../../helper/services/shared-data.service';
import { HelperService } from '../../helper/services/helper.service';

@Component({
    selector: 'app-reset-password-page',
    imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
],
    templateUrl: './reset-password-page.component.html',
    styleUrl: './reset-password-page.component.scss'
})
export class ResetPasswordPageComponent implements OnInit {
  resetForm!: FormGroup;
  submitted = false;
  resetSuccessful = false;
  resetError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private courseManagerService: CourseManagerService,
    private sharedDataService: SharedDataService,
    private helperService: HelperService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('auth_token') ?? '';

    this.resetForm = this.fb.group({
      token: [token, Validators.required],
      newPassword: ['', [Validators.required]]
    });
  }

  async submit(): Promise<void> {
    this.resetError = null;
  
    if (this.resetForm.invalid) return;
  
    const { token, newPassword } = this.resetForm.value;
  
    try {
      await this.courseManagerService.changePasswordAfterReset(token, newPassword);
      this.resetSuccessful = true;
  
      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 2000);
    } catch (error: any) {
      console.error('Fehler beim Zurücksetzen:', error);
  
      if (error?.error?.description === 'RESPONSE_RESOURCE_MISSING') {
        this.resetError = 'Der Link ist ungültig oder abgelaufen.\n\nBitte versuche erneut, dein Passwort zurückzusetzen.\n\nDu kannst jederzeit über die Login-Seite einen neuen Link anfordern.';
      } else {
        this.resetError = 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.';
      }
      this.sharedDataService.toggleProgressBarOff()
    }
  }
}